module.exports = __webpack_public_path__ + "media/images/user-head-04c18f56a9d33cc31c7029bc934c36eb.svg";